import { ReportModalConfig } from '@features/siteStatusV2/components/reports/types/commun';
import React from 'react';
import { Modal as BootstrapModal, Container, ModalBody, Row } from 'react-bootstrap';
import styled, { keyframes } from 'styled-components';

import ActivitiesColumn from './ActivitiesColumn';
import InformationsColumn from './InformationsColumn';

interface ReportModal {
  showReportModal: boolean;
  onHide: () => void;
  report: ReportModalConfig;
}

const ReportModal: React.FC<ReportModal> = ({ showReportModal, onHide, report }) => (
  <Modal show={showReportModal} onHide={onHide}>
    <ModalBody className="p-0">
      <Container>
        <Row>
          <InformationsColumn report={report} onHide={onHide} />
          <ActivitiesColumn id={report.header.ticketId} />
        </Row>
      </Container>
    </ModalBody>
  </Modal>
);

const slideIn = keyframes`
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  `;

const slideOut = keyframes`
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(100%);
      opacity: 0;
    }
  `;

const Modal = styled(BootstrapModal)`
  .modal-dialog {
    height: 100vh;
    max-width: 100%;
    width: 50vw;
    margin: 0;
    position: fixed;
    right: 0;
    top: 0;
    animation: ${({ show }: { show: boolean }) => (show ? slideIn : slideOut)} 0.7s ease-out;
  }

  .modal-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 0;
    border: none;
  }

  .modal-body {
    flex: 1;
    overflow-y: auto;
  }
`;

export default ReportModal;
